<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Objekti</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>

            <v-form ref="form">
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Objekat<span v-if="selectedItem.id"> id: {{selectedItem.id}}</span></span>
                <span v-if="selectedItem.category" class="px-4">Kategorija {{selectedItem.category.name}}</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <!--NOVA POLJA-->
                <v-col cols="6" class="px-3">
                    <v-switch v-model="notification" inset label="Notifikacije"></v-switch>
                </v-col>
                <v-col cols="6" class="px-3">
                    <v-switch v-model="selectedItem.status" inset label="Status"></v-switch>
                </v-col>
                <v-col cols="6" class="px-3">
                    <v-switch v-model="selectedItem.home_page" inset label="Naslovna strana"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                            :items="categories"
                            v-model="selectedItem.category"
                            dense
                            label="Kategorija **"
                            outlined
                            item-value="id"
                            item-text="name"
                            return-object
                              :rules="fieldRules"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                              :items="categories"
                              v-model="selectedItem.categories_other"
                              dense
                              label="Ostale kategorije"
                              outlined
                              item-value="id"
                              item-text="name"
                              return-object
                              multiple
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.position"
                            dense
                            label="Pozicija"
                            outlined
                            type="number"
                            :rules="fieldRules"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.phone"
                            dense
                            label="Telefon"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.fax"
                            dense
                            label="Fax"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.email"
                            dense
                            label="Email"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-file-input
                            v-model="selectedItem.image"
                            dense
                            label="Slika"
                            prepend-icon=""
                            outlined
                            @change="fileSelected($event)"
                    >
                        <template v-slot:selection="{ file, index, text }">
                            <template v-if="typeof file === 'object'">
                                <span class="caption">{{file.name}}</span>
                            </template>
                            <template v-else>
                                <span class="caption">{{file}}</span>
                            </template>
                        </template>
                    </v-file-input>
                </v-col>
                <v-col cols="12" sm="12">
                    <v-row no-gutters>
                        <v-col cols="12" sm="6">
                            <v-col cols="12" sm="12" class="px-2 py-0">
                                <v-text-field
                                        v-model="selectedItem.web"
                                        dense
                                        label="Web"
                                        outlined
                                ></v-text-field>
                            </v-col>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-card style="height: 104px;text-align: center;">
                                <v-card-text class="py-1" v-if="previewImage">
                                    <img :src="previewImage" height="95px"/>
                                </v-card-text>
                                <v-card-text class="py-1" v-else-if="selectedItem.image">
                                    <img :src="config.apiUrl + '/data/' + $store.state.site.id + '/objects/' + selectedItem.id +'/'+ selectedItem.image" height="95px"/>
                                </v-card-text>
                            </v-card>

                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" class="px-2 pt-4">
                    <v-select
                            v-model="selectedItem.include_in_layout"
                            :items="['latest news', 'all news', 'contact-data-bottom', 'contact-data-right', 'image-header', 'contact-form']"
                            label="Ukljuceno na layout"
                            multiple
                            outlined
                            dense
                    ></v-select>
                </v-col>

                <!-- // NOVA POLJA-->
                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="px-2 mt-4">
                    <v-tabs v-model="tab" background-color="primary" dark height="40">
                        <v-tab v-for="item in selectedItem.langs" :key="item.id">
                            {{ item.lang.name }}
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in selectedItem.langs" :key="item.id">
                            <v-card>
                                <v-card-text>
                                    <v-row no-gutters>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.name"
                                                    dense
                                                    label="Naziv"
                                                    outlined
                                                    @input="seo(item)"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="px-2">
                                            <v-text-field
                                                    v-model="item.address"
                                                    dense
                                                    label="Adresa"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="px-2">
                                            <v-text-field
                                                    v-model="item.city"
                                                    dense
                                                    label="Grad"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" class="px-2">
                                            <v-text-field
                                                    v-model="item.seo_url"
                                                    dense
                                                    label="Seo url"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" class="px-2">
                                            <v-combobox
                                                    v-model="item.keywords"
                                                    dense
                                                    outlined
                                                    label="Kljucne reci"
                                                    multiple
                                                    small-chips
                                            ></v-combobox>
                                        </v-col>

                                        <template v-for="field in selectedItem.extra_fields">
                                            <v-col cols="12" sm="12" class="px-2">
                                                <template v-if="field.type === 'text'">
                                                    <v-text-field
                                                            v-model="field.langs[item.lang.lang_code].value"
                                                            dense
                                                            :label="field.langs[item.lang.lang_code].text"
                                                            outlined
                                                    ></v-text-field>
                                                </template>
                                                <template v-else-if="field.type === 'textarea'">
                                                    <v-textarea
                                                            outlined
                                                            :label="field.langs[item.lang.lang_code].text"
                                                            auto-grow
                                                            v-model="field.langs[item.lang.lang_code].value"
                                                            rows="1"
                                                            row-height="15"
                                                    ></v-textarea>
                                                </template>
                                                <template v-else>
                                                    <v-text-field
                                                            v-model="field.langs[item.lang.lang_code].value"
                                                            dense
                                                            :label="field.langs[item.lang.lang_code].text"
                                                            outlined
                                                            :type="field.type"
                                                    ></v-text-field>
                                                </template>
                                            </v-col>
                                        </template>

                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.meta_description"
                                                    dense
                                                    label="Meta opis"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.short_description"
                                                    dense
                                                    label="Kratki opis"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="px-2">
                                            <span>Opis</span>
                                            <ckeditor
                                                    v-model="item.description"
                                                    :config="editorConfig">
                                            </ckeditor>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>

                <v-row align="center" class="white mt-3 pa-3" no-gutters>
                    <span class="title green--text text--darken-3">Album</span>
                    <v-col class="d-flex mb-3" cols="12">
                        <v-divider></v-divider>
                    </v-col>

                    <v-col cols="12" v-if="album.length">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Options</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in album" :key="item.id">
                                    <td>{{ item.langs[0].name }}</td>
                                    <td>
                                        <v-btn icon :to="{name: 'fotografije-create', params: {item: item}}">
                                            <v-icon small>{{'mdi-pencil'}}</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>

                </v-row>

                <v-col cols="12" class="mt-2">
                    <v-row justify="center">
                        <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                    </v-row>
                </v-col>
            </v-row>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
    import bitPage from "../../components/layout/page";
    //import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import {Datetime} from 'vue-datetime';
    import config from '../../config';
    import { db } from '../../firebase';
    import axios from 'axios';

    export default {
        components: {
            bitPage,
            datetime: Datetime
        },
        head() {
            return {
                title: 'BitLab CMS'
            }
        },
        data: () => ({
            config: config,
            breadcrumbs: [
                {
                    text: 'Objekti',
                    disabled: false,
                    to: {name: 'objekti'},
                },
                {
                    text: 'Dodavanje novog objekta',
                    disabled: true
                },
            ],
            items: [],
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            //editor: ClassicEditor,
            editorData: '<p>Rich-text editor content.</p>',
            editorConfig: {
                extraPlugins: 'justify'
            },
            selectedItem: {
                position: null,
                parent_id: null,
                extra_fields: [],
                langs: []
            },
            tab: null,
            categories: [],
            fieldRules: [
                v => !!v || 'Field is required'
            ],
            previewImage: null,
            album: [],
            objects: [],
            notification: false
        }),
        firestore() {
            return {
                objects: db.collection('objects'),
            }
        },
        created() {
            if (this.$route.params.item) {
                this.selectedItem = this.$route.params.item;
                this.getLangs();
                this.selectedItem.langs.forEach(lang => {
                    return lang.keywords = lang.keywords && lang.keywords.split(',')
                        ? lang.keywords.split(',') : []
                })

                this.selectedItem.include_in_layout = this.selectedItem.include_in_layout && this.selectedItem.include_in_layout.split(',')
                    ? this.selectedItem.include_in_layout.split(',') : []

            } else {
                this.getLangs();
                this.getField();

                if(this.$route.params.category) this.selectedItem.category = this.$route.params.category
            }
            this.getCategory();
            this.getAlbum();
        },
        methods: {
            getField() {
                this.axios.get(`/option`).then(res => {
                    this.selectedItem.extra_fields = res.data.fields
                })
            },
            getLangs() {
                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    console.log(res)
                    res.forEach(lang => {
                        let check = this.selectedItem.langs.find(item => item.lang_id === lang.id)
                        if(!check) {
                            this.selectedItem.langs.push({
                                name: null,
                                seo_url: null,
                                meta_description: null,
                                keywords: null,
                                short_description: null,
                                description: null,
                                lang: lang,
                                lang_id: lang.id,
                                file: null
                            })
                        }
                        })
                    })
            },
            getCategory() {
                this.categories = [];
                this.axios.get(`/category/all?type=object`)
                    .then(res =>

                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.name ? lang.name : '';
                            if (item['name'] !== '') this.categories.push(item)
                        })

                    )
            },
            save() {
                if(this.$refs.form.validate()) {

                    this.selectedItem.category_id = this.selectedItem.category ? this.selectedItem.category.id : null;
                    this.selectedItem.parent_id = this.selectedItem.parent ? this.selectedItem.parent.id : null;

                    let data = new FormData();
                    data.append('item', JSON.stringify(this.selectedItem));
                    data.append('image', this.selectedItem.image);

                    if (this.$route.params.item && !this.$route.params.sub) {
                        data.append('_method', 'PUT');
                        this.axios.post(`/object/${this.$route.params.item.id}`, data).then(res => {
                            if(this.notification) {
                              this.sendNotificattion(this.selectedItem.langs[0].title, this.$route.params.item.id);
                            }
                        }).finally(() => {
                          this.$router.push({name: 'objekti'})
                        })
                    } else {
                        this.axios.post(`/object`, data).then(res => {
                            if(this.notification) {
                                this.sendNotificattion(res.data.data.langs[0].name, res.data.data.id);
                            }
                        }).finally(() => {
                          this.$router.push({name: 'objekti'})
                        })
                    }

                }
                else {
                    this.$vuetify.goTo(0, [])
                }
            },
            seo(item) {
                item.seo_url = item.name.toLowerCase()
                    .replace(/ /g,'-')
                    .replace(/[^\w-]+/g,'')
            },
            fileSelected(evt) {
                if(evt) {
                    var reader = new FileReader()
                    reader.readAsDataURL(evt)
                    reader.onload = () => {
                        this.previewImage = reader.result;
                    };
                }
                else {
                    this.previewImage = null
                }
            },
            getAlbum() {
                this.axios.get(`/photo-album?object_id=${this.selectedItem.id}`)
                    .then(res => this.album = res.data)
            },
            sendNotificattion(title , id) {
                axios.post('https://fcm.googleapis.com/fcm/send',
                    {
                        to: "/topics/objects." + this.$store.state.site.id,
                        collapse_key: "type_a",
                        notification: {
                            title: title
                        },
                        data: {
                            site_id: this.$store.state.site.id,
                            title: title,
                            id: id
                        }
                    },
                    {
                        headers: {
                            Authorization: 'key=' + config.token
                        }
                    }
                ).then(res => {
                    console.log(res)
                })
            }
        },
        computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            }
        },
        watch: {
            setLang() {
                this.getCategory();
            }
        }
    }
</script>
